import React from 'react';
import AnimatedRouter from 'react-animated-router';
import { Navigate, Route } from 'react-router-dom';
import Password from './modules/Password';
import PasswordReset from './modules/Password/Reset';
import PasswordSuccess from './modules/Password/Success';
import PasswordVerify from './modules/Password/Verify';

// 账户相关业务（含非登录态情况的）
const Account: React.FC = () => {
    return (
        <AnimatedRouter timeout={300}>
            <Route path="password" element={<Password />}>
                <Route index element={<Navigate to="verify" replace />} />
                <Route path="verify" element={<PasswordVerify />} />
                <Route path="reset" element={<PasswordReset />} />
                <Route path="success" element={<PasswordSuccess />} />
            </Route>
            <Route path="*" element={<Navigate to="/profile" />} />
        </AnimatedRouter>
    );
};

export default Account;
